import {NgModule} from '@angular/core';
import {PartnerSearchComponent} from "./partner-search.component";
import {SelectSearchDataModule} from "../../../../../../components/common/select-search-data/select-search-data.module";
import {
    TagsSummaryFieldComponent
} from "../../../../../common/tag/api/components/tags-summary-field/tags-summary-field.component";
import {NgIf} from "@angular/common";
import {PartnerSummaryItemModule} from "../partner-summary-item/partner-summary-item.module";

@NgModule({
    declarations: [
        PartnerSearchComponent,
    ],
    exports: [
        PartnerSearchComponent
    ],
    imports: [
        SelectSearchDataModule,
        TagsSummaryFieldComponent,
        NgIf,
        PartnerSummaryItemModule,
    ]
})
export class PartnerSearchModule {}
